// import "core-js/stable";
// import "regenerator-runtime/runtime";

import ExpandableDetails from "scripts/ExpandableDetails.js";
import FormManager from "scripts/FormManager.js";
import ScrollManager from "scripts/ScrollManager.js";
import ModalManager from "scripts/SimpleModal.js";

import "styles/index.scss";

let scrollManager = null;

// -- USE CASES -- //

function initExpandableDetails(elements) {
  let l = elements.length;
  for (let i = 0; i < l; i++) {
    const details = new ExpandableDetails(elements[i]);
    details.init();
  }
}

// -- CONTACT FORM RENDERING -- //

function showFormSuccess() {
  const section = document.getElementById("contact");
  const form = document.getElementById("contact-form");

  const message = document.createElement("p");
  message.classList.add("form-success-message");
  message.textContent = "Thanks for your interest, we'll be in touch shortly";

  section.insertBefore(message, form);
}

// -- DEEP LINKS -- //

function initDeepLinks() {
  const path = window.location.pathname;

  if (path.indexOf("/result") > -1) {
    showFormSuccess();
    scrollManager.scrollToAnchor("#contact", true);
  }

  if (path.indexOf("/contact") > -1) {
    scrollManager.scrollToAnchor("#contact", true);
  }
}

// -- STARTUP -- //

function init() {
  // init use cases section
  const expandableDetails =
    document.getElementsByClassName("expandable-details");
  if (expandableDetails) {
    initExpandableDetails(expandableDetails);
  }

  // init contact form
  const contactForm = document.getElementById("contact-form");
  if (contactForm) {
    const formManager = new FormManager(contactForm);
    formManager.init();
  }

  // setup scroll animations
  scrollManager = new ScrollManager();
  scrollManager.init();

  // set up contact button
  const contactButton = document.getElementById("contact-button");
  contactButton.addEventListener("click", scrollManager.scrollToAnchorEvent);

  // set up video modal
  const modal = document.getElementById("simple-modal");
  if (modal) {
    const modalManager = new ModalManager(modal);
    modalManager.init();
  }

  // setup deep links
  setTimeout(initDeepLinks, 100);
}

//  Really simple page ready detection.
function ready(init) {
  if (document.readyState !== "loading") {
    // console.log("ready readyState");
    init();
  } else {
    // console.log("ready DOMContentLoaded");
    document.addEventListener("DOMContentLoaded", init);
  }
}

ready(init);
